import React from 'react'
import Column from '@amzn/meridian/column'
import Text from '@amzn/meridian/text'
import Divider from '@amzn/meridian/divider'
import { ToggleSetting, SettingsMenuItem } from './components'
import { INotificationPreferences } from './services/PreferencesService'
import { useBundle } from '@amzn/react-arb-tools'
import { BUNDLE_NAME } from '@src/constants'
import { t } from '@src/translationHelper'
import { NotificationSubPage } from './constants/profileSettings'

interface INotificationSettingsProps {
    preferences: INotificationPreferences
    onUpdate: (updates: Partial<INotificationPreferences>) => void
    onNavigate: (subPage: NotificationSubPage) => void
}

/**
 * Notification Settings page (Figma Screen 32).
 * Shows quiet time toggle, critical alerts toggle, and navigation to
 * Push notifications sub-page. SMS and Email are disabled for M0.
 */
export const NotificationSettings: React.FC<INotificationSettingsProps> = ({
    preferences,
    onUpdate,
    onNavigate,
}) => {
    const [bundle] = useBundle(BUNDLE_NAME)
    return (
        <Column spacing="400" spacingInset="400">
            <Text type="h300">{t(bundle, 'jsma-web-profile-notificationSettingsTitle')}</Text>

            <ToggleSetting
                label={t(bundle, 'jsma-web-profile-quietTime')}
                description={t(bundle, 'jsma-web-profile-quietTimeDesc')}
                checked={preferences.quietTimeEnabled}
                onChange={(checked) => onUpdate({ quietTimeEnabled: checked })}
                testId="quiet-time-toggle"
            />

            <ToggleSetting
                label={t(bundle, 'jsma-web-profile-criticalAlerts')}
                description={t(bundle, 'jsma-web-profile-criticalAlertsDesc')}
                checked={preferences.criticalAlertsEnabled}
                onChange={(checked) => onUpdate({ criticalAlertsEnabled: checked })}
                testId="critical-alerts-toggle"
            />

            <Divider />

            <Text type="b300" color="secondary">{t(bundle, 'jsma-web-profile-typesOfNotifications')}</Text>

            <SettingsMenuItem
                label={t(bundle, 'jsma-web-profile-pushNotifications')}
                onClick={() => onNavigate('push')}
                testId="menu-push-notifications"
            />
        </Column>
    )
}
